"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _react = _interopRequireDefault(require("react"));

var _shotTypes = _interopRequireDefault(require("../../constants/shotTypes"));

var _default = function _default(ShotComponent, shotType) {
  var FileUpdater = function FileUpdater(props) {
    var handleFilesChange = function handleFilesChange(passedFiles) {
      var addFileToQueue, updateShotAssets, organisationId, newAssetsIds, assetId;
      return _regenerator.default.async(function handleFilesChange$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              addFileToQueue = props.addFileToQueue, updateShotAssets = props.updateShotAssets, organisationId = props.organisationId;

              if (passedFiles.length) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              _context.next = 5;
              return _regenerator.default.awrap(Promise.all(passedFiles.map(function (file) {
                return addFileToQueue({
                  file: file
                }, organisationId);
              })));

            case 5:
              newAssetsIds = _context.sent;
              assetId = newAssetsIds[0];
              _context.next = 9;
              return _regenerator.default.awrap(updateShotAssets(newAssetsIds));

            case 9:
              if (shotType === _shotTypes.default.NEW_SHOT) {
                props.createShot(assetId);
              } else {
                props.updateShot({
                  assetId: assetId
                });
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      });
    };

    return _react.default.createElement(ShotComponent, (0, _extends2.default)({
      handleFilesChange: handleFilesChange
    }, props));
  };

  FileUpdater.displayName = 'WithFileUpdater';
  return FileUpdater;
};

exports.default = _default;